<template>
  <a-layout style="width: 100%; height: 100%">
    <a-layout-sider id="user_info_section" width="260px">
      <div class="img_section">
        <img src="../../assets/user_info.png" class="img_title" />{{
          $t("message")["DeviceSummary.baseinfo"]
        }}
        <img
          src="../../assets/edit.png"
          id="img_edit"
          @click="edit_user_info"
          v-if="device_type == 1"
        />
      </div>

      <div class="profile">
        <div class="item">
          <img src="../../assets/cat.png" class="img_avator" />
        </div>
        <div class="item">
          <div id="row1">
            <p id="lb_nickname">{{ this.userBase.name }}</p>
            <img :src="gender_img_url" class="img_logo" />
          </div>
          <div id="row2">
            <img src="../../assets/phone.png" class="img_logo" />
            <p id="lb_phone">13662284509</p>
          </div>
        </div>
      </div>
      <div
        class="dotted_line"
        style="margin-top: 20px; margin-bottom: 25px"
      ></div>
      <div class="info_div">
        <div class="info_inner_div_left">
          <img src="../../assets/height.png" class="info_div_logo" />
          <p class="info_lb left_lb">
            {{ $t("message")["DeviceSummary.height"] }}:
          </p>
        </div>
        <p class="info_lb right_lb">{{ userBase.height }}</p>
      </div>

      <div class="info_div">
        <div class="info_inner_div_left">
          <img src="../../assets/weight.png" class="info_div_logo" />
          <p class="info_lb left_lb">
            {{ $t("message")["DeviceSummary.weight"] }}:
          </p>
        </div>
        <p class="info_lb right_lb">{{ userBase.weight }}</p>
      </div>

      <div class="info_div">
        <div class="info_inner_div_left">
          <img src="../../assets/birthday.png" class="info_div_logo" />
          <p class="info_lb left_lb">
            {{ $t("message")["DeviceSummary.birthday"] }}:
          </p>
        </div>
        <p class="info_lb right_lb">{{ userInfo.birthday }}</p>
      </div>
      <div class="dotted_line" style="margin-top: 25px"></div>
      <div class="img_section">
        <img src="../../assets/user_info.png" class="img_title" />{{
          $t("message")["DeviceSummary.deviceinfo"]
        }}
      </div>
      <div class="info_title">{{ $t("message")["DeviceList.deviceid"] }}:</div>
      <div class="info_value">{{ deviceid }}</div>
      <div></div>
      <div
        class="dotted_line"
        style="margin-top: 20px; margin-bottom: 25px"
      ></div>
      <div style="margin-bottom: 20px" class="body_center_bg">
        <img src="../../assets/bracelet.png" id="device_img_big" />
        <span style="color: #2284ff; font-size: 14px; padding-left: 6px">{{
          watchTitle
        }}</span>

        <div class="body-center body_position">
          <img :src="nb_img" id="device_status_img" />
          <div id="oline_div">{{ onlineStr }}</div>
          <div
            style="
              color: #00bc98;
              font-size: 12px;
              display: inline;
              margin-right: 5px;
            "
          >
            <img src="../../assets/battery_img.png" id="battery_img" />&nbsp;{{
              battery
            }}
          </div>
        </div>
      </div>
      <div id="watch_use_stat_div">
        {{ $t("message")["DeviceSummary.binded"] }}
        <span class="info_num">{{ binded }}</span>
        {{ $t("message")["DeviceSummary.day"] }},
        {{ $t("message")["DeviceSummary.wear"] }}
        <span class="info_num">{{ weared }}</span>
        {{ $t("message")["DeviceSummary.day"] }}
      </div>
      <div class="btn_action_div" v-if="device_type == 1">
        <a-button @click="data_sync" class="primaryBtn">{{
          $t("message")["DeviceSummary.datasync"]
        }}</a-button>
        <a-popconfirm
          :title="$t('message')['DeviceSummary.resetdevice.notice']"
          @confirm="reset_device"
        >
          <a-button class="primaryBtn">{{
            $t("message")["DeviceSummary.resetdevice"]
          }}</a-button>
        </a-popconfirm>
      </div>
      <a-spin size="large" :spinning="loading" />
    </a-layout-sider>

    <a-layout-content id="health-main">
      <a-tabs :activeKey="activeKey" @change="handleClick">
        <a-tab-pane :tab="$t('message')['DeviceSummary.summary']" key="survey">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.hr']" key="heart">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.rri']" key="atrial">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.ecg']" key="ecg">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.sport']" key="sport">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.sleep']" key="sleep">
          <div></div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('message')['DeviceSummary.gnss']" key="gnss">
          <div></div>
        </a-tab-pane>
      </a-tabs>
      <div id="healthy_ai">
        <div id="healthy_box">
          <components
            :is="currentView"
            :userData="usetInt"
            :userStep="userStep"
            v-on:childEvent="showMsgFromChild"
          ></components>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
// eslint-disable-line
import HealthSummary from "../Health/HealthSummary.vue";
// eslint-disable-line
import Chatbot from "../../components/ai/Chatbot.vue";
// eslint-disable-line
import EcgAnalyze from "../Health/EcgAnalyze.vue";
// eslint-disable-line
import AtrialAnalyze from "../Health/AtrialAnalyze.vue";
// eslint-disable-line
import HeartRateAnalyze from "../Health/HeartRateAnalyze.vue";
// eslint-disable-line
import SportAnalyze from "../Health/SportAnalyze.vue";
// eslint-disable-line
import SleepAnalyze from "../Health/SleepAnalyze.vue";
import GnssAnalyze from "../Health/GnssAnalyze.vue";
import request from "../../utils/request";
import { getAge } from "../../utils/toolbox";
import { notification } from "ant-design-vue";

import domain from "../../domain";
export default {
  components: {
    HealthSummary,
    Chatbot,
    EcgAnalyze,
    AtrialAnalyze,
    HeartRateAnalyze,
    SportAnalyze,
    SleepAnalyze,
    GnssAnalyze,
  },

  data() {
    return {
      fullSreen: true,
      deviceid: "N/A",
      device_type: 1,
      uid: "N/A",
      model: "",
      battery: "N/A",
      activeKey: "survey",
      currentView: "",
      aiView: "Chatbot",
      watchTitle: "",
      userStep: 0,
      userBase: {
        name: "N/A",
        sex: "N/A",
        age: "N/A",
        height: "N/A",
        weight: "N/A",
        birthday: "N/A",
      },
      userInfo: {
        nickname: "",
        gender: 0,
        height: 0,
        weight: 0,
        birthday: "",
        target_step: 0,
        target_calorie: 0,
      },
      usetInt: { name: "N/A", sex: 1, age: 0, height: 0, weight: 0 },
      user_item: [],
      userHealthy: { heart: 0, atrial: 1, step: 0, sleep: 0, ecg: 2 },
      onlineStr: "N/A",
      loading: false,
      gender_img_url: "",
      binded: 400,
      weared: 356,
      nb_img: require("@/assets/connect.png"),
    };
  },
  mounted() {
    this.device_type = sessionStorage.getItem("device_type");
    this.deviceid = sessionStorage.getItem("deviceid");
    if (this.device_type == 2) {
      this.uid = sessionStorage.getItem("uid");
    }
    this.model = this.$route.params.model;
    if (this.model != undefined) {
      sessionStorage.setItem("device_model", this.model);
    } else {
      this.model = sessionStorage.getItem("device_model");
    }
    console.log(
      "device_type,deviceid,uid:",
      this.device_type,
      this.deviceid,
      this.uid
    );

    if (this.device_type == 2) {
      this.watchTitle = this.$t("message")["DeviceSummary.blewatchname"];
      this.getUserInfo(this.uid);
    } else {
      this.watchTitle = this.$t("message")["DeviceSummary.watchname"];
      if (typeof this.$route.params.battery == "number") {
        this.battery = this.$route.params.battery + "%";
        sessionStorage.setItem("battery", this.$route.params.battery);
      } else {
        this.battery = sessionStorage.getItem("battery") + "%";
      }

      this.getDeviceUserInfo(this.deviceid);
      this.getDeviceStatus();
    }
  },
  methods: {
    handleClick(key) {
      this.activeKey = key;
      switch (key) {
        case "survey":
          this.currentView = "HealthSummary";
          break;
        case "heart":
          this.currentView = "HeartRateAnalyze";
          break;
        case "atrial":
          this.currentView = "AtrialAnalyze";
          break;
        case "ecg":
          this.currentView = "EcgAnalyze";
          break;
        case "sport":
          this.currentView = "SportAnalyze";
          break;
        case "sleep":
          this.currentView = "SleepAnalyze";
          break;
        case "gnss":
          this.currentView = "GnssAnalyze";
          break;
      }
    },
    showMsgFromChild: function () {
      let lineTime = 1500;
      if (lineTime <= 1800) {
        this.onlineStr = this.$t("message")["DeviceSummary.online"];
        this.nb_img = require("@/assets/connect.png");
      } else {
        this.onlineStr = this.$t("message")["DeviceSummary.offline"];
        this.nb_img = require("@/assets/disconnect.png");
      }
    },
    getUserInfo(uid) {
      this.currentView = "HealthSummary";
      let that = this;
      request({
        //调用接口
        method: "GET",
        url: domain.URLS.UserInfo_BLE_Url,
        emulateJSON: true,
        emulateHttp: true,
        params: {
          uid: uid,
        },
      }).then(
        function (response) {
          console.log(response.data.ReturnCode);
          if (response.data.ReturnCode == 0) {
            let userinfo = response.data.Data;
            that.refreshUserInfo(userinfo);
          } else {
            that.setuserItem();
          }
        },
        function (error) {
          console.log(error.data);
        }
      );
    },
    getDeviceUserInfo(deviceid) {
      this.currentView = "HealthSummary";
      let that = this;
      request({
        //调用接口
        method: "GET",
        url: domain.URLS.UserInfo_4GDevice_Url,
        emulateJSON: true,
        emulateHttp: true,
        params: {
          deviceid: deviceid,
        },
      }).then(
        function (response) {
          console.log("response.data:", response.data);
          if (response.data.ReturnCode == 0) {
            let userinfo = response.data.Data;
            that.refreshUserInfo(userinfo);
          } else {
            let userinfo = {
              nickname: "N/A",
              gender: 0,
              height: 0,
              weight: 0,
              birthday: "N/A",
              target_step: 0,
              target_calorie: 0,
            };
            that.refreshUserInfo(userinfo);
          }
        },
        function (error) {
          let userinfo = {
            nickname: "N/A",
            gender: 0,
            height: 0,
            weight: 0,
            birthday: "N/A",
            target_step: 0,
            target_calorie: 0,
          };
          that.refreshUserInfo(userinfo);
          console.log(error.data);
        }
      );
    },
    gotoSetting() {
      this.$router.push({
        name: "device_settings",
        params: {
          deviceid: this.deviceid,
        },
      });
    },
    data_sync() {
      const data = {
        device_id: this.deviceid,
      };
      let that = this;
      this.loading = true;
      let reqUrl = domain.URLS.Sync_Device_DataCmd_Url;
      if (this.model != "" && this.model != undefined) {
        reqUrl = reqUrl + "?device_model=" + this.model;
      }

      request({
        method: "POST",
        url: reqUrl,
        emulateJSON: true,
        emulateHttp: true,
        data: data,
      })
        .then((response) => {
          console.log(response.data);
          that.loading = false;
          notification.info({
            // eslint-disable-next-line no-unused-vars
            message: (h) => (
              <div>
                <span style="color: green">success</span>
              </div>
            ),
            description: response.data.RrpcCode,
          });
        })
        .catch((error) => {
          console.log(error);
          that.loading = false;
          notification.info({
            // eslint-disable-next-line no-unused-vars
            message: (h) => (
              <div>
                <span style="color: red">fail</span>
              </div>
            ),
            // description: response.data.RrpcCode,
          });
        });
    },
    reset_device() {
      const data = {
        device_id: this.deviceid,
      };
      let that = this;
      this.loading = true;
      let reqUrl = domain.URLS.Reset_Device_url;
      if (this.model != "" && this.model != undefined) {
        reqUrl = reqUrl + "?device_model=" + this.model;
      }

      request({
        method: "POST",
        url: reqUrl,
        emulateJSON: true,
        emulateHttp: true,
        data: data,
      })
        .then((response) => {
          console.log(response.data);
          that.loading = false;
          notification.info({
            // eslint-disable-next-line no-unused-vars
            message: (h) => (
              <div>
                <span style="color: green">success</span>
              </div>
            ),
            description: response.data.RrpcCode,
          });
          that.getDeviceUserInfo(that.deviceid);
        })
        .catch((error) => {
          console.log(error);
          that.loading = false;
          notification.info({
            // eslint-disable-next-line no-unused-vars
            message: (h) => (
              <div>
                <span style="color: red">fail</span>
              </div>
            ),
            // description: response.data.RrpcCode,
          });
          that.getDeviceUserInfo(that.deviceid);
        });
    },
    refreshUserInfo(userinfo) {
      let {
        nickname,
        gender,
        height,
        weight,
        birthday,
        target_step,
        target_calorie,
      } = userinfo;
      console.log("userinfo:", nickname, gender, height, weight, birthday);
      sessionStorage.setItem("nickname", nickname);
      this.userInfo.nickname = nickname;
      this.userInfo.gender = gender;
      this.userInfo.height = height;
      this.userInfo.weight = weight;
      this.userInfo.birthday = birthday;
      this.userInfo.target_step = target_step;
      this.userInfo.target_calorie = target_calorie;

      this.userBase.name = nickname;
      this.userBase.height = height + "cm";
      if (height == 0) {
        this.userBase.height = "N/A";
      }
      this.userBase.weight = weight + "kg";
      if (weight == 0) {
        this.userBase.weight = "N/A";
      }
      this.userBase.birthday = birthday;
      this.userBase.age = getAge(birthday);
      if (gender == 1) {
        this.userBase.sex = this.$t("message")["DeviceSummary.male"];
        this.gender_img_url = require("@/assets/male.png");
      } else if (gender == 2) {
        this.userBase.sex = this.$t("message")["DeviceSummary.female"];
        this.gender_img_url = require("@/assets/female.png");
      } else {
        this.userBase.sex = "N/A";
      }
      this.setuserItem();
    },
    setuserItem() {
      if (this.device_type == 1) {
        this.user_item = [
          {
            title: this.$t("message")["DeviceSummary.gender"],
            message: this.userBase.sex,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.height"],
            message: this.userBase.height,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.weight"],
            message: this.userBase.weight,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.birthday"],
            message: this.userBase.birthday,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.imei"],
            message: this.deviceid,
            show: true,
          },
        ];
      } else {
        this.user_item = [
          { title: "Uid", message: this.uid, show: true },
          {
            title: this.$t("message")["DeviceSummary.gender"],
            message: this.userBase.sex,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.height"],
            message: this.userBase.height,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.weight"],
            message: this.userBase.weight,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.birthday"],
            message: this.userBase.birthday,
            show: true,
          },
          {
            title: this.$t("message")["DeviceSummary.imei"],
            message: this.deviceid,
            show: true,
          },
        ];
      }
    },
    edit_user_info() {
      this.$router.push({
        name: "userinfoedit",
        params: {
          data_date: this.$route.params.data_date,
          model: this.$route.params.model,
          battery: this.$route.params.battery,
          step: this.$route.params.step,
          nickname: this.userInfo.nickname,
          gender: this.userInfo.gender,
          height: this.userInfo.height,
          weight: this.userInfo.weight,
          birthday: this.userInfo.birthday,
          target_step: this.userInfo.target_step,
          target_calorie: this.userInfo.target_calorie,
        },
      });
    },
    getDeviceStatus() {
      let params = { device_id: this.deviceid, device_model: this.model };
      if (this.model == "" || this.model == undefined) {
        params = { device_id: this.deviceid };
      }
      let that = this;
      request({
        //调用接口
        method: "GET",
        url: domain.URLS.DeviceStatus_4G_Url,
        emulateJSON: true,
        emulateHttp: true,
        params: params,
      }).then(
        function (response) {
          console.log("device status: ", response.data.Data.status);
          if (response.data.ReturnCode == 0) {
            if (response.data.Data.status == 1) {
              that.onlineStr = that.$t("message")["DeviceSummary.online"];
              that.nb_img = require("@/assets/connect.png");
            } else {
              that.onlineStr = that.$t("message")["DeviceSummary.offline"];
              that.nb_img = require("@/assets/disconnect.png");
            }
          }
        },
        function (error) {
          console.log(error.data);
        }
      );
    },
  },
  created() {
    this.setuserItem();
  },
};
</script>

<style scoped lang="scss">
@import "../style/GlobalStyle.scss";

#user_info_section {
  width: 200px;
  height: 100%;
  padding-left: 20px;
  float: left;
  text-align: left;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

#health-main {
  display: flex;
  flex-direction: column;
  text-align: left;
  border-left: 1px solid #e5e5e5;
  width: 100%;
  height: 850px;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

#healthy_box {
  width: 95%;
  min-width: 580px;
  height: 780px;
  margin-top: 6px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

#healthy_ai {
  text-align: left;
  min-width: 350px;
  width: 100%;
}

.img_section {
  height: 30px;
  line-height: 30px;
  color: #2284ff;
  font-size: 16px;
  margin-top: 10px;
}

.img_title {
  width: 13px;
  height: 20px;
  vertical-align: middle;
  margin-right: 6px;
}

#img_edit {
  width: 28px;
  height: 28px;
  float: right;
  margin-right: 15px;
}

.profile {
  display: flex;
  margin-top: 20px;
  height: 60px;
}

.item {
  margin-right: 10px;
}

.img_avator {
  height: 50px;
  width: 50px;
  border: 1px solid #2284ff;
  border-radius: 50%;
}

.img_logo {
  height: 14px;
  width: 14px;
  margin-right: 5px;
}

#row1 {
  display: flex;
  align-items: center;
  height: 30px;
}

#row2 {
  display: flex;
  align-items: center;
  height: 30px;
}

#lb_nickname {
  color: #343434;
  font-size: 14px;
  margin-right: 6px;
  margin-top: 10px;
}

#lb_phone {
  color: #727272;
  font-size: 12px;
  margin-top: 10px;
}

.info_div {
  display: flex;
  align-items: center;
  margin-top: 12px;
  height: 40px;
  background-color: #f5f7fa;
}

.info_inner_div_left {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.info_lb {
  margin: 0;
  color: #5b5e65;
  font-size: 12px;
}

.left_lb {
  margin-left: 5px;
}

.right_lb {
  margin-left: auto;
  margin-right: 5px;
}

.info_div_logo {
  height: 15px;
  width: 15px;
  margin-left: 5px;
}

#btn_edit {
  font-size: 14px;
  margin-right: 10px;
}

.body-center {
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 2px;
}

.info_posi {
  position: absolute;
  top: 28px;
  right: 0px;
  bottom: 10px;
  left: 50px;
  margin-bottom: 30px;
}

.btn_action_div {
  font-size: 12px;
  color: #999999;
  margin-top: 15px;
  letter-spacing: 0;
  text-align: left;
  line-height: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 200px;
}

.info_title {
  font-size: 12px;
  color: #999999;
  line-height: 12px;
  letter-spacing: 1;
  margin-top: 15px;
}

.info_value {
  font-size: 14px;
  color: #343434;
  line-height: 14px;
  margin-top: 15px;
}

.info_num {
  font-size: 12px;
  color: #2284ff;
}

.dotted_line {
  height: 1px;
  width: 100%;
  border-top: 1px dashed #e5e5e5;
}

#device_img_small {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 6px;
}

#device_img_big {
  height: 52px;
  width: 28px;
  float: left;
  margin-right: 7px;
}

#oline_div {
  color: #2284ff;
  font-size: 12px;
  margin-right: 10px;
}

#battery_img {
  width: 16px;
  height: 10px;
  margin-left: 5px;
  margin-right: 3px;
}

.body_center_bg {
  padding-top: 15px;
  padding-left: 10px;
  width: 200px;
  height: 78px;
  border-radius: 4px;
  background: #ebeeee;
  position: relative;
}

.body_position {
  position: absolute;
  left: 50px;
  top: 25px;
  right: 10px;
  bottom: 0;
}

.primaryBtn {
  background-color: #2284ff;
  color: #ffffff;
  font-size: 12px;
}

#device_status_img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

#watch_use_stat_div {
  font-size: 12px;
  color: #5b5e65;
}
</style>
